﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import DIWButtonDropdown from '@/controls/diw.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import DIWViewport from '@/basics/diw.viewport';
import DIWSearch from '@/controls/diw.search';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import DIWDialog from '@/components/diw.dialog';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKPrice from '@tk/components/tk.price';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@/controls/diw.form.validator';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import DIWCarousel from '@/components/diw.carousel';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFormRangeslider from '@tk/controls/tk.form.rangeslider';
import TKSelection from '@tk/controls/tk.selection';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';
import { configureStore } from '@tk/utilities/tk.use.store';
import DIWMinibasket from '@/components/diw.minibasket';
import DIWProductTile from '@/components/diw.product.tile';
import DIWStock from '@/components/diw.stock';
import DIWPrice from '@/components/diw.price';
import DIWArticleList from '@/components/diw.article.list';
import DIWPriceControl from '@/components/diw.price.control';
import DIWLinks from '@/components/diw.links';
import DIWFollow from '@/components/diw.follow';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/struct.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Struct extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-button-dropdown', constructor: DIWButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'diw-search', constructor: DIWSearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'diw-product-tile', constructor: DIWProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-article-list', constructor: DIWArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-carousel', constructor: DIWCarousel },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-form-range-slider', constructor: TKFormRangeslider },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'diw-minibasket', constructor: DIWMinibasket },
            { name: 'diw-stock', constructor: DIWStock },
            { name: 'diw-price', constructor: DIWPrice },
            { name: 'diw-price-control', constructor: DIWPriceControl },
            { name: 'diw-links', constructor: DIWLinks },
            { name: 'diw-follow', constructor: DIWFollow },
        ]);
    }
}

new Struct();
